import type {SenseAction} from 'src/action-creators/types';
import type {LanguageTranslationKeyAndValue} from 'src/types/messages';
import invert from 'lodash/invert';

import {
  RECEIVE_ALL_SUPPORTED_LANGUAGES,
  SET_CANDIDATE_LANG_CODE,
} from 'src/action-creators/chat/language-translation';


export type State = {
  languages: LanguageTranslationKeyAndValue;
  languageCodeToNameMapping: LanguageTranslationKeyAndValue;
  candidateLanguages: LanguageTranslationKeyAndValue;
};

const initialState = {
  languages: {},
  languageCodeToNameMapping: {},
  candidateLanguages: {},
} as const;

export default function reduce(
  state: State | null | undefined = initialState,
  action: SenseAction,
): State {
  switch (action.type) {
    case RECEIVE_ALL_SUPPORTED_LANGUAGES: {
      // @ts-expect-error - TS2322 - Type '{ languages: LanguageTranslationKeyAndValue; languageCodeToNameMapping: Dictionary<string>; candidateLanguages?: LanguageTranslationKeyAndValue | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        languages: action.payload,
        languageCodeToNameMapping: invert(action.payload),
      };
    }
    case SET_CANDIDATE_LANG_CODE: {
      // @ts-expect-error - TS2322 - Type '{ candidateLanguages: { [x: string]: string; }; languages?: LanguageTranslationKeyAndValue | undefined; languageCodeToNameMapping?: LanguageTranslationKeyAndValue | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        candidateLanguages: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.candidateLanguages,
          [action.payload.id]: action.payload.langCode,
        },
      };
    }

    default:
      // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
      return state;
  }
}
